var _g, _circle, _path, _path2, _path3, _path4, _path5, _rect, _circle2, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentEmployees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5452_12726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 38,
    height: 38,
    rx: 10,
    fill: "url(#paint0_linear_5452_12726)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0942,
    cy: 12.9223,
    r: 4.36765,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3672 20.0264H32.8271V18.7988C36.6189 19.9657 39.375 23.4964 39.375 27.6709V29.0332C39.375 29.9106 38.7846 30.6775 37.9297 30.875C35.9696 31.3279 32.4174 32.0535 29.8359 32.0381C27.4212 32.0236 24.1116 31.3257 22.2451 30.8818C21.3957 30.6797 20.8126 29.9161 20.8125 29.043V27.6709C20.8125 23.4939 23.5719 19.9616 27.3672 18.7969V20.0264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9062 27.7887L29.071 22.2031H31.1092L32.2739 28.0827L30.2357 29.8465L27.9062 27.7887Z",
    fill: "white",
    stroke: "#01B280",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9062 20.5703L28.8422 22.7541H31.338L32.2739 20.5703H27.9062Z",
    fill: "white",
    stroke: "#01B280",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3635 22.7509L25.7656 20.0825L28.4554 18.6562L30.0933 20.5671L27.3635 22.7509Z",
    fill: "white",
    stroke: "#01B280",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8208 22.7509L34.3203 20.0231L31.7289 18.6562L30.091 20.5671L32.8208 22.7509Z",
    fill: "white",
    stroke: "#01B280",
    strokeWidth: 1.06356,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22.7891,
    width: 14.75,
    height: 14.75,
    rx: 7.375,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.3711,
    cy: 29.9727,
    r: 5.80859,
    fill: "#01B280"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6245 27.9851C42.6167 27.8236 42.5399 27.6778 42.4246 27.5704C42.3094 27.4629 42.1558 27.4089 41.9943 27.4245C41.8329 27.4323 41.6871 27.5091 41.5871 27.6244L38.5143 31.0813L37.1091 29.8057C36.9939 29.6982 36.8402 29.6442 36.6788 29.652C36.5173 29.6598 36.3715 29.7288 36.2716 29.8441C36.1641 29.9593 36.1101 30.1129 36.1179 30.2744C36.1257 30.4358 36.1947 30.5817 36.31 30.6816L38.1615 32.3638C38.2689 32.4637 38.415 32.5174 38.5609 32.5174H38.5993C38.7529 32.5096 38.8988 32.4406 39.014 32.3176L42.4862 28.4076C42.5786 28.2924 42.6323 28.1387 42.6245 27.9851Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5452_12726",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5452_12726"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5452_12726"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5452_12726"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5452_12726",
    result: "effect2_dropShadow_5452_12726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5452_12726",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5452_12726",
    x1: 12,
    y1: 2,
    x2: 50,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentEmployees);
export default __webpack_public_path__ + "static/media/Present Employees.5ae197bf33e2a0106f68e3e787fe522c.svg";
export { ForwardRef as ReactComponent };